import {PropsWithChildren, useEffect} from "react";
import {useAuth0} from "@auth0/auth0-react";
import {logout, setAuthToken} from "../../store/auth/actions";
import {useAppThunkDispatch} from "../../store/hooks/useAppThunkDispatch";

export const Auth0Bridge = (props: PropsWithChildren<unknown>) => {
  const {children} = props;

  const {
    isAuthenticated,
    isLoading: auth0Loading,
    user: auth0User,
    getAccessTokenSilently
  } = useAuth0();

  const dispatch = useAppThunkDispatch();

  useEffect(() => {
    let cancelled = false;

    const syncAuth0 = async () => {
      if (auth0Loading) {
        return
      }

      if (!isAuthenticated || !auth0User) {
        dispatch(logout());
        return
      }

      try {
        const token = await getAccessTokenSilently()
        if (!cancelled) {
          dispatch(setAuthToken(`Bearer ${token}`));
        }
      } catch (err) {
        console.error("Auth0 token error", err);
        if (!cancelled) {
          dispatch(logout());
        }
      }
    }

    syncAuth0();

    return () => {
      cancelled = true;
    }
  }, [isAuthenticated, auth0Loading, auth0User, getAccessTokenSilently, dispatch]);

  if (auth0Loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-700">
        <div className="text-center">
          <div
            className="mb-4 h-10 w-10 rounded-full border-2 border-[#12284C] border-t-transparent animate-spin mx-auto"/>
          <p className="text-sm text-slate-500">Loading authentication…</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {children}
    </>
  )
}
